export const engagementAppGroupIdCloudStorageCapability = "/engagement/:app_group_id/cloud_storage_capability";
